export default "__VITE_ASSET__14ffcdbb__"